/*
 * ============================
 * File: index.js
 * Project: Octavia-Admin
 * File Created: Thursday, 9th April 2020 2:11:05 am
 * Author:UILIB
 * AuthorUrl:https://ui-lib.com/
 * -----
 * Last Modified: Saturday, 18th April 2020 9:32:52 pm
 * Modified By: naime hossain (naime.hossain93@gmail.com)
 * -----
 * Copyright 2020 - 2021 UILIB, UILIB
 * ============================
 */

// Imports
import Vue from "vue";
import Router from "vue-router";
import store from "@/store";
import authenticate from "@/auth/authenticate";

Vue.use(Router);


const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior: (to, from, savedPosition) => {
    if (to.hash) return { selector: to.hash };
    if (savedPosition) return savedPosition;
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: "/login",
      component: () => import("@/views/app/sessions/SignInTwo"),
    },
    {
      path: "/",
      component: () => import("@/views/app/Index"),
      beforeEnter: authenticate,
      redirect: {name: 'license-management'},
      children: [
        {
          path: "/:customer?",
          component: () => import("@/views/app/dashboard/Index"),
          redirect: {name: "license-management"},

          children: [
            {
              path: "license-management",
              name: "license-management",
              component: () =>
                import("@/views/LicenseManagement"),
              meta: {
                title: "License Management",
              },
            },
            {
              path: "license-cart/:orgId",
              name: "license-cart",
              props: true,
              component: () =>
                import("@/views/LicenseCart"),
              meta: {
                title: "License Cart",
              },
            }
          ],
        },
      ],
    }
  ],
});

router.beforeEach((to, from, next) => {
  // If this isn't an initial page load.

  if (to.path) {
    // Start the route progress bar.
    store.dispatch("changeThemeLoadingState", true);

    // let path = to.path
    // next({path: path, params: {customer: 'ihg'}});

  }
  // }
  next();
});

router.afterEach(() => {
  // Complete the animation of the route progress bar.
  // setTimeout(() => store.dispatch('changeThemeLoadingState', false), 500);
  store.dispatch("changeThemeLoadingState", false);
});

export default router;
